import React from 'react';
import '../../App.css';
import HeroSection from '../HeroSection';
import Information from '../Information';
import Footer from '../Footer';
import Recommendations from '../Recommendations';
import PhotoGallery from '../PhotoGallery';
import Parents from '../Parents';

function Home() {
    return (
        <>
            <HeroSection />
            <Parents />
            <Information />
            <Recommendations />
            <PhotoGallery />
            <Footer />
        </>
    )
}

export default Home;